import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Box, Typography } from "@mui/material";
import { Button } from "Components/_Shared/Buttons/Button";
import { Flex } from "Components/_Shared/Core/Flex";
import { HStack } from "Components/_Shared/Core/Stack";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

type Props = {
  readonly onClick: () => void;
};

export const InvestmentsNsureCustomSolutionPanel = ({ onClick }: Props) => {
  const { t } = useResource();

  return (
    <Box
      px={Spacing.XL}
      py={Spacing.L}
      bgcolor="grey.50"
      sx={(theme) => ({
        boxSizing: "border-box",
        borderRadius: "12px",
        boxShadow: `0 0 0 1px ${theme.palette.divider}`,
      })}
    >
      <HStack alignItems="center" gap={Spacing.L} flexWrap="wrap">
        <Flex
          alignItems="center"
          justifyContent="center"
          width={48}
          height={48}
          flexShrink={0}
          bgcolor="background.paper"
          sx={{ borderRadius: "50%" }}
        >
          <EditOutlinedIcon sx={{ fontSize: 24, color: "text.secondary" }} />
        </Flex>

        <Box flex={1} minWidth={220}>
          <Typography variant="body1" fontWeight={600}>
            {t(Resources.AnalysisDetail.GoalsFulfillment.Nsure.SolutionSelect.CustomSolution)}
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block">
            {t(Resources.AnalysisDetail.GoalsFulfillment.Nsure.SolutionSelect.CustomSolutionDescription)}
          </Typography>
        </Box>

        <Button
          variant="contained"
          color="secondary"
          onClick={onClick}
          endAdornment={<KeyboardArrowRightIcon fontSize="small" sx={{ position: "relative", top: "-1px" }} />}
        >
          {t(Resources.AnalysisDetail.GoalsFulfillment.Nsure.SolutionSelect.CustomSolutionAction)}
        </Button>
      </HStack>
    </Box>
  );
};
